if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.variantIdInput.disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				this.submitButtonText = this.submitButton.querySelector("span");

				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				const submitToCart = () => {
					this.submitButton.setAttribute("aria-disabled", true);
					this.submitButton.classList.add("loading");
					this.querySelector(".loading__spinner").classList.remove("hidden");

					const config = fetchConfig("javascript");
					config.headers["X-Requested-With"] = "XMLHttpRequest";
					delete config.headers["Content-Type"];

					const formData = new FormData(this.form);
					if (this.cart) {
						formData.append(
							"sections",
							this.cart.getSectionsToRender().map((section) => section.id),
						);
						formData.append("sections_url", window.location.pathname);
						this.cart.setActiveElement(document.activeElement);
					}
					config.body = formData;

					fetch(`${routes.cart_add_url}`, config)
						.then((response) => response.json())
						.then((response) => {
							if (response.status) {
								publish(PUB_SUB_EVENTS.cartError, {
									source: "product-form",
									productVariantId: formData.get("id"),
									errors: response.errors || response.description,
									message: response.message,
								});
								this.handleErrorMessage(response.description);

								const soldOutMessage =
									this.submitButton.querySelector(".sold-out-message");
								if (!soldOutMessage) return;
								this.submitButton.setAttribute("aria-disabled", true);
								this.submitButtonText.classList.add("hidden");
								soldOutMessage.classList.remove("hidden");
								this.error = true;
								return;
							} else if (!this.cart) {
								window.location = window.routes.cart_url;
								return;
							}

							const startMarker = CartPerformance.createStartingMarker(
								"add:wait-for-subscribers",
							);
							if (!this.error)
								publish(PUB_SUB_EVENTS.cartUpdate, {
									source: "product-form",
									productVariantId: formData.get("id"),
									cartData: response,
								}).then(() => {
									CartPerformance.measureFromMarker(
										"add:wait-for-subscribers",
										startMarker,
									);
								});
							this.error = false;
							const quickAddModal = this.closest("quick-add-modal");
							if (quickAddModal) {
								document.body.addEventListener(
									"modalClosed",
									() => {
										setTimeout(() => {
											CartPerformance.measure("add:paint-updated-sections", () => {
												this.cart.renderContents(response);
											});
										});
									},
									{ once: true },
								);
								quickAddModal.hide(true);
							} else {
								CartPerformance.measure("add:paint-updated-sections", () => {
									this.cart.renderContents(response);
								});
							}
						})
						.catch((e) => {
							console.error(e);
						})
						.finally(() => {
							this.submitButton.classList.remove("loading");
							if (this.cart && this.cart.classList.contains("is-empty"))
								this.cart.classList.remove("is-empty");
							if (!this.error) this.submitButton.removeAttribute("aria-disabled");
							this.querySelector(".loading__spinner").classList.add("hidden");

							CartPerformance.measureFromEvent("add:user-action", evt);
						});
				};

				const productId = String(this.dataset.productId || "").trim();
				const variantId = String(this.variantIdInput?.value || "").trim();
				const isDigitalProduct = this.dataset.digitalProduct === "true";

				if (isDigitalProduct && productId && variantId) {
					fetch("/cart.js")
						.then((response) => response.json())
						.then((cart) => {
							const cartHasSameProduct = cart.items.some(
								(item) =>
									productId === String(item.product_id)
							);

							if (!cartHasSameProduct) {
								submitToCart();
								return;
							}

							this.showDuplicateDigitalProductModal();
							this.submitButton.classList.remove("loading");
							this.submitButton.removeAttribute("aria-disabled");
							this.querySelector(".loading__spinner").classList.add("hidden");
						})
						.catch((e) => {
							console.error(e);
							submitToCart();
						});
					return;
				}

				submitToCart();
			}

			showDuplicateDigitalProductModal() {
				const existingModal = document.getElementById(
					"digital-product-warning-modal",
				);
				if (existingModal) existingModal.remove();

				const modal = document.createElement("div");
				modal.id = "digital-product-warning-modal";
				modal.setAttribute("role", "dialog");
				modal.setAttribute("aria-modal", "true");
				modal.setAttribute("aria-labelledby", "digital-product-warning-title");
				modal.style.position = "fixed";
				modal.style.top = "0";
				modal.style.left = "0";
				modal.style.right = "0";
				modal.style.bottom = "0";
				modal.style.background = "rgba(0, 0, 0, 0.6)";
				modal.style.display = "flex";
				modal.style.alignItems = "center";
				modal.style.justifyContent = "center";
				modal.style.zIndex = "9999";
				modal.style.padding = "20px";

				modal.innerHTML = `
					<div style="background: #fff; border-radius: 8px; max-width: 420px; width: 100%; padding: 24px; box-shadow: 0 16px 48px rgba(0,0,0,0.2);">
						<h3 id="digital-product-warning-title" style="margin: 0 0 12px; font-size: 16px;">Digital item already in cart</h3>
						<p style="margin: 0 0 20px; line-height: 1.5;">This digital product is already in your cart. You can only add it once.</p>
						<div style="display: flex; justify-content: flex-end; gap: 12px;">
							<button type="button" class="button button--secondary js-digital-warning-close">Close</button>
						</div>
					</div>
				`;

				document.body.appendChild(modal);
				const closeButton = modal.querySelector(".js-digital-warning-close");
				closeButton.addEventListener("click", () => modal.remove());
				modal.addEventListener("click", (event) => {
					if (event.target === modal) modal.remove();
				});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(".product-form__error-message");

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}

			toggleSubmitButton(disable = true, text) {
				if (disable) {
					this.submitButton.setAttribute("disabled", "disabled");
					if (text) this.submitButtonText.textContent = text;
				} else {
					this.submitButton.removeAttribute("disabled");
					this.submitButtonText.textContent =
						this.dataset.addToCartLabel || window.variantStrings.addToCart;
				}
			}

			get variantIdInput() {
				return this.form.querySelector("[name=id]");
			}
		},
	);
}
